export const initialFilters = {
  difficulty: {
    easy: false,
    medium: false,
    hard: false,
  },
  playerMode: {
    single: false,
    multi: false,
  },
  tags: [],
};
